<!-- 员工管理 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea StaffManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        
        <!-- 搜索区域 -->
        <div class="searchDiv">
          <el-input class="w200" placeholder="请输入姓名" v-model="keyword.user_name" clearable @change="getStaffList"></el-input>
          <el-input class="w200" placeholder="请输入账号" v-model="keyword.user_account" clearable @change="getStaffList"></el-input>
          <el-input class="w200" placeholder="请输入手机号码" v-model="keyword.phone_no" clearable @change="getStaffList"></el-input>
          <el-button class="searchBtn" type="primary" @click="getStaffList()">搜 索</el-button>
        </div>

        <!-- 添加 -->
        <div class="addButton">
          <el-button type="primary" @click="operateUserInfo('add')">添加</el-button>
        </div>

        <!--用户信息table-->
        <div class="userListTable">
          <el-table
            v-loading="staffData.loading"
            :data="staffData.list"
            style="width: 96%">
            <el-table-column
              type="index"
              label="序号"
              width="80">
            </el-table-column>
            <el-table-column
              prop="user_name"
              label="姓名"
              width="100">
            </el-table-column>
            <el-table-column
              prop="user_account"
              label="账号">
            </el-table-column>
            <el-table-column
              prop="phone_no"
              label="手机号码">
            </el-table-column>
            <el-table-column
              prop="email"
              label="邮箱">
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间">
            </el-table-column>
            <el-table-column
              label="状态">
              <template slot-scope="scope">
                <el-button type="text" @click="operateUserInfo('changeStatus',scope.row)">{{ scope.row.user_status}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="operateUserInfo('alter', scope.row)">修改</el-button>
                <el-button type="text" @click="authAllot(scope.row.user_id)">权限分配</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="paging" v-if="staffData.paging.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="staffData.paging.page"
            layout="prev, pager, next, jumper"
            :page-count="staffData.paging.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 状态 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'changeStatus'">
            <p class="text">
              当前用户状态为
              <span class="bold">
                {{dialogData.info.user_status}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.user_state === '1' ? '禁用' : '正常'}}？
                </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeStaffStatus()">{{dialogData.info.user_state === '1' ? '禁用' : '正常'}}</el-button>
            </div>
          </div>

          <!-- 添加或修改用户信息 -->
          <div v-else>
            <el-form
              label-width="80px"
              :model="dialogData.info">
              <el-form-item label="姓名:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_name"></el-input>
                </div>
              </el-form-item>
              <el-input style="position:fixed;bottom:-9999px"></el-input>
              <el-input type="password" style="position:fixed;bottom:-9999px"></el-input>
              <el-form-item label="账号:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_account" placeholder="字母或者数字的组合，限制6~15位" autocomplete="new-user"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="密码:">
                <div class="inputBox" v-if="dialogData.info.isAlter">
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass" placeholder="[要更改保存的密码，请单击这里]"></el-input>
                </div>
                <div class="inputBox" v-else>
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="手机号码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.phone_no" autocomplete="new-phone"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="邮箱:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.email"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="confirm()">确 认</el-button>
            </div>
          </div>
        </el-dialog>


      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { 
    updataBreadCrumb,
    showToast,
    deepCopy
  } from "../../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../../static/js/api.js"

  export default {
    name: 'StaffManage',
    components:{
      BreadCrumb
    },
    data() {
      return {

        //关键词搜索
        keyword:{
          user_name:'',//姓名
          user_account:'',//账号
          phone_no:'',//手机号
        },

        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 员工列表信息
        staffData: {
          // 分页数据  page为当前页，perPage为每页数量
          paging: {
            page: 1,
            perPage: 10
          },
          // 员工列表
          list:[],
          loading: false
        }
      }
    },
    mounted(){
      this.getStaffList()
    },
    created: async function () {
    },
    methods: {
      // 当前页值改变，获取新的员工列表
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.getStaffList()
      },
      // 数据处理
      processData: function (data) {
        let list = data.list
        for (let i in list) {
          let listItem = list[i]
          // 获取状态
          listItem.user_status = listItem.user_state === '1' ? '正常' : '禁用'
        }
        this.staffData.list = list
        // 总页码
        this.staffData.paging.pageCount = data.pageCount
      },
      // 获取用户列表信息
      getStaffList: async function () {
        let vm = this
        let data = vm.staffData.paging
        data.user_account = vm.keyword.user_account
        data.user_name = vm.keyword.user_name
        data.phone_no = vm.keyword.phone_no

        vm.staffData.loading = true
        let res = await systemApi.getStaffList(data)
        vm.staffData.loading = false
        if (res.meta.code === 200) {
          vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
        // console.log('res', res)
      },
      // 操作用户信息（添加或修改）
      operateUserInfo: function (type, info) {
        console.log('添加用户');
        let infoNull = {
          user_name: '' ,
          phone_no: '',
          email: '',
          user_account:'',
          password:'',
        }
        if(type == 'alter'){
          info.password=''
          info.isAlter = '1'
        }
        this.dialogData = {
          type: type,
          title: type === 'changeStatus' ? '' : type === 'add' ? '添加用户' : '修改用户信息',
          visible: !(this.dialogData.visible),
          info: info ? deepCopy(info) : infoNull
        }
        // console.log('this', this.dialogData)
      },
      // 修改员工状态
      changeStaffStatus: async function () {
        let vm = this
        let data = {
          user_id: vm.dialogData.info.user_id
        }
        let res = await systemApi.changeStaffStatus(data)
        if (res.meta.code === 200) {
          this.dialogData.visible = !(this.dialogData.visible)
          showToast('修改成功')
          vm.getStaffList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新员工信息
      updateStaffInfo: async function (data) {
        let vm = this
        let res = await systemApi.updateStaffInfo(data)
        if (res.meta.code === 200) {
          vm.dialogData.visible = !(vm.dialogData.visible)
          showToast(data.user_id === '' ? '添加成功' : '修改成功')
          vm.getStaffList()
        } else {
          showToast(res.meta.message)
        }
        console.log('res', res)
      },
      // 确认更新员工信息
      confirm: function () {
        let vm = this
        let data = {
          user_id: vm.dialogData.type === 'add' ? '' : vm.dialogData.info.user_id ,
          user_name: vm.dialogData.info.user_name ,
          phone_no: vm.dialogData.info.phone_no,
          email: vm.dialogData.info.email,
          user_account: vm.dialogData.info.user_account,
        }
        if(vm.dialogData.info.isAlter){
          if(vm.dialogData.info.password){
            data.password= vm.dialogData.info.password
          }
        }else{
          data.password= vm.dialogData.info.password
        }
        // 判断值
        if (data.user_name === '') {
          showToast('姓名不能为空！')
          return false
        }
        let reUser = new RegExp(/^[0-9a-zA-Z]{6,15}$/)
        if (data.user_account === '') {
          showToast('账号不能为空！')
          return
        } else if (!reUser.test(data.user_account)) {
          showToast('请填写6-15位字母和数字组合的账号')
          return
        }
        let rePass = new RegExp(/^[\w]{6,20}$/)
        if (data.password === '') {
          showToast('密码不能为空！')
          return
        } else if (!rePass.test(data.password)) {
          showToast('请填写6-20位字母、数字和下划线组合的密码')
          return
        }
        let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
        if (data.phone_no === '') {
          showToast('手机号码不能为空！')
          return false
        }else if(!rePhone.test(data.phone_no)){
          showToast('请填写11位有效的手机号码')
          return
        }
        if (data.email === '') {
          showToast('邮箱不能为空！')
          return false
        }
        vm.updateStaffInfo(data)
        console.log(this.dialogData.info);
      },
      // 权限分配
      authAllot(user_id) {
        console.log('user_id: ',user_id);
        let navBarActive = [{function_type: 'AuthAllot', function_name: '权限分配'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/AuthAllot',
          query: {user_id: user_id}
        })
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
.addButton {
}
.userListTable {
  margin-top: 24px;
}
.searchDiv{
  display: flex;
  margin-bottom: 20px;
  .w200{
    width: 200px;
    margin-right: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Page/System/StaffManage/SIndex.vue